var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeterinaryBriefcase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "veterinary-briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4307 36.4283H38.5735M30 27.8569V44.9997M42.8578 14.9997V6.42829C42.8578 5.29164 42.4063 4.20156 41.6026 3.39783C40.7989 2.59411 39.7088 2.14258 38.5721 2.14258H21.4293C20.2926 2.14258 19.2025 2.59411 18.3988 3.39783C17.5951 4.20156 17.1436 5.29164 17.1436 6.42829V14.9997M53.5721 14.9997H6.42927C4.06233 14.9997 2.14355 16.9185 2.14355 19.2854V53.5711C2.14355 55.9381 4.06233 57.8569 6.42927 57.8569H53.5721C55.9391 57.8569 57.8578 55.9381 57.8578 53.5711V19.2854C57.8578 16.9185 55.9391 14.9997 53.5721 14.9997Z",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeterinaryBriefcase);
export default __webpack_public_path__ + "static/media/veterinary-briefcase.9c839ce03596c05f4d891c0cfcb1b134.svg";
export { ForwardRef as ReactComponent };